import script from "./BaseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=2e0647ec&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0647ec"]])

export default __exports__